import React from 'react';
import { useLanguage } from '@/contexts/language/LanguageContext';

const IntegrationSection = () => {
  const { t } = useLanguage();

  return (
    <section className="py-20 bg-white">
      <div className="container-custom max-w-5xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left Side - Content */}
          <div>
            {/* Badge */}
            <div className="inline-block px-4 py-2 rounded-md bg-foreground text-white text-xs font-medium mb-6">
              {t('integrationTitle')}
            </div>

            {/* Heading */}
            <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-6 leading-tight">
              {t('integrationHeading')}
            </h2>

            {/* Description */}
            <p className="text-base md:text-lg text-muted-foreground leading-relaxed">
              {t('integrationSubtitle')}
            </p>
          </div>

          {/* Right Side - Integration Logos Grid (3×3, colourful) */}
          <div className="flex items-center justify-center">
            <div className="w-full max-w-xl rounded-3xl bg-[#E8EBFF] p-8">
              <div className="grid grid-cols-3 gap-6 items-center justify-items-center">
                {[
                  { src: '/lovable-uploads/aws_icon.png', alt: 'AWS' },
                  { src: '/lovable-uploads/bq_icon.png', alt: 'BigQuery' },
                  { src: '/lovable-uploads/looker_info.png', alt: 'Looker' },
                  { src: '/lovable-uploads/azure_icon.png', alt: 'Microsoft Azure' },
                  { src: '/lovable-uploads/openai_icon.png', alt: 'OpenAI' },
                  { src: '/lovable-uploads/python_icon.png', alt: 'Python' },
                  { src: '/lovable-uploads/dbt_icon.png', alt: 'dbt' },
                  { src: '/lovable-uploads/powerbi_icon.png', alt: 'Power BI' },
                  { src: '/lovable-uploads/excel_icon.png', alt: 'Excel', smaller: true },
                ].map((logo) => (
                  <div
                    key={logo.alt}
                    className="w-16 h-16 rounded-full bg-white flex items-center justify-center shadow-sm hover:shadow-md transition-shadow p-2"
                  >
                    <img
                      src={logo.src}
                      alt={logo.alt}
                      className={`object-contain ${logo.smaller ? 'h-[72%] w-[72%]' : 'h-full w-full'}`}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntegrationSection;
